module.exports = __webpack_public_path__ + "static/4-4d3bbe85f902edf588f8bb68fe3f43c4.jpg";